<template>
  <div class="not-found">
    <img src="../assets/img/no-auth.png" alt="">
    <div>
      <h1>很抱歉，您没有权限访问！</h1>
      <p class='btn-primary' @click="gotoOut">退出</p>
    </div>
  </div>
</template>
<script>
  export default {
    methods:{
      gotoOut(){
        this.$router.push({name: 'routePage', query: {pageType: 'DO_LOGOUT'}})
      },
    }
  }
</script>
<style lang="scss" scoped>
  .not-found{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%);
    margin-left:-1rem;
    text-align: center;
    img{
      width:70%;
      margin: 0px auto;
    }
    h1{
      font-weight: normal;
      margin: .2rem auto;
      font-size: .16rem;
    }
  }
</style>